module.exports = __webpack_public_path__ + "fonts/Libre_Franklin-500-vietnamese7.0925fd7.woff2";